import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5ae7996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-modal-shell__body" }
const _hoisted_2 = { class: "detail-modal-shell__main" }
const _hoisted_3 = { class: "detail-modal-shell__illustration" }

import { computed, provide } from 'vue';
import CustomDialog from '@/components/custom-dialog/CustomDialog.vue';
import DetailTopicLottie, {
  type DetailLottieTopic,
} from '@/components/shared/detail-topic-lottie/DetailTopicLottie.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailModalShell',
  props: {
    isDisplay: { type: Boolean },
    title: {},
    lottieTopic: {},
    width: { default: '50%' },
    size: { default: 'lg' },
    closeOnBackdropClick: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any) {





/** Same inject key as PageContentSection so ResponsiveLayout uses illustrated field layout. */
const hasIllustration = computed(() => true);
provide('pageContentSectionHasIllustration', hasIllustration);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomDialog, {
    "is-display": _ctx.isDisplay,
    title: _ctx.title,
    width: _ctx.width,
    size: _ctx.size,
    "close-on-backdrop-click": _ctx.closeOnBackdropClick,
    onOnCloseIconClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, _createSlots({
    "dialog-content": _withCtx(() => [
      _renderSlot(_ctx.$slots, "alert"),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(DetailTopicLottie, { topic: _ctx.lottieTopic }, null, 8, ["topic"])
        ])
      ])
    ]),
    _: 2
  }, [
    (_ctx.$slots.footer)
      ? {
          name: "dialog-footer",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer")
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["is-display", "title", "width", "size", "close-on-backdrop-click"]))
}
}

})